import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface MyAccountOrderDetailsContainerStyles {
    container?: InjectableCss;
}

export const MyAccountOrderDetailsStyles: MyAccountOrderDetailsContainerStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            padding: 5px;
            padding-left: 0;
            max-width: 100%;
            > div[class^="Wrapper"] {
                > div[class^="GridWrapper"] {
                    > div:first-child[class^="GridOffset"] {
                        > div:first-child {
                            > div[class^="Wrapper"] {
                                > div[class^="GridWrapper"] {
                                    ${({ theme }: { theme: BaseTheme }) =>
                                        breakpointMediaQueries(theme, [
                                            null,
                                            null,
                                            null,
                                            null,
                                            css`
                                                > div:first-child[class^="GridOffset"] {
                                                    > div:first-child {
                                                        flex-basis: 50%;
                                                        max-width: 100%;
                                                    }
                                                    > div:nth-child(2) {
                                                        flex-basis: 50%;
                                                        max-width: 100%;
                                                        > div[class^="Wrapper"] {
                                                            > div[class^="ContentWrapper"] {
                                                                padding-bottom: 10px;
                                                                > h4 {
                                                                    font-size: 20px;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    > div:nth-child(3) {
                                                        > div[class^="Wrapper"] {
                                                            > div[class^="ContentWrapper"] {
                                                                padding-bottom: 10px;
                                                                > h4 {
                                                                    font-size: 20px;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            `,
                                        ])}
                                }
                            }
                        }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                    `,
                    css`
                        display: block;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};

const styles = MyAccountOrderDetailsStyles;

const MyAccountOrderDetailsContainer: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="MyAccountWrapper">
            <Zone contentId={id} zoneName="Content1" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyAccountOrderDetailsContainer,
    definition: {
        displayName: "My Account OrderDetails Container",
        group: "My Account",
    },
};

export default widgetModule;
